const HUBSPOT_FORMS_SCRIPT_ID = 'hubspot-forms-script'
const HUBSPOT_FORMS_SCRIPT_SRC = 'https://js.hsforms.net/forms/embed/v2.js'
const HUBSPOT_TRACKING_SCRIPT_ID = 'hs-script-loader'
const HUBSPOT_TRACKING_SCRIPT_SRC = 'https://js.hs-scripts.com/5157245.js'

let formsScriptPromise = null
let trackingScriptPromise = null

function loadScript (id, src, isReady = () => false) {
  if (isReady()) {
    return Promise.resolve()
  }

  const existingScript = document.getElementById(id)
  if (existingScript) {
    return new Promise((resolve, reject) => {
      existingScript.addEventListener('load', () => resolve(), { once: true })
      existingScript.addEventListener('error', () => reject(new Error(`Failed to load ${src}`)), { once: true })
    })
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.id = id
    script.src = src
    script.charset = 'utf-8'
    script.type = 'text/javascript'
    script.async = true
    script.defer = true
    script.addEventListener('load', () => resolve(), { once: true })
    script.addEventListener('error', () => {
      script.remove()
      reject(new Error(`Failed to load ${src}`))
    }, { once: true })
    document.head.appendChild(script)
  })
}

export function loadHubspotForms () {
  if (window.hbspt && window.hbspt.forms) {
    return Promise.resolve()
  }

  if (!formsScriptPromise) {
    formsScriptPromise = loadScript(
      HUBSPOT_FORMS_SCRIPT_ID,
      HUBSPOT_FORMS_SCRIPT_SRC,
      () => Boolean(window.hbspt && window.hbspt.forms)
    ).then(() => {
      if (!window.hbspt || !window.hbspt.forms) {
        throw new Error('HubSpot forms API is unavailable')
      }
    }).catch(error => {
      formsScriptPromise = null
      throw error
    })
  }

  return formsScriptPromise
}

export function loadHubspotTracking () {
  if (document.getElementById(HUBSPOT_TRACKING_SCRIPT_ID)) {
    return Promise.resolve()
  }

  if (!trackingScriptPromise) {
    trackingScriptPromise = loadScript(
      HUBSPOT_TRACKING_SCRIPT_ID,
      HUBSPOT_TRACKING_SCRIPT_SRC
    ).catch(error => {
      trackingScriptPromise = null
      throw error
    })
  }

  return trackingScriptPromise
}

export function resetHubspotLoaders () {
  formsScriptPromise = null
  trackingScriptPromise = null
}
